export default "__VITE_ASSET__D3WZV_MB__"